<template>
  <div>
    <div
      v-if="deferredPrompt && firstPopup() && !neverPopup()"
      class="popup-app-install-rest"
    ></div>
    <div
      v-if="deferredPrompt && !neverPopup()"
      :class="
        firstPopup()
          ? 'popup-app-install-first'
          : checkIfMobileByUA()
          ? 'popup-app-install-mobile'
          : 'popup-app-install'
      "
    >
      <img
        v-if="firstPopup()"
        class="logo-app-install"
        src="../../../public/img/icons/android-chrome-512x512.png"
        alt=""
      />
      <img
        v-else-if="!checkIfMobileByUA()"
        class="logo-app-install"
        src="../../assets/img/logo_white.png"
      />
      {{
        checkIfMobileByUA()
          ? "Installer l'application ?"
          : 'Vous pouvez directement installer un raccourci de cette application sur votre bureau.'
      }}
      <!-- Vous pouvez ajouter directement un raccourci vers cette application dans votre menu. -->
      <div class="buttons-app-install">
        <button class="button-app-install" text @click="install">
          Ajouter
        </button>
        <button
          class="button-app-install button-app-install-none"
          text
          @click="dismiss"
        >
          Non merci
        </button>
      </div>
      <svg
        @click="closePopup"
        class="close-app-install"
        style="enable-background: new 0 0 24 24"
        version="1.1"
        viewBox="0 0 24 24"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="grid_system" />
        <g id="_icons">
          <path
            fill="white"
            d="M5.3,18.7C5.5,18.9,5.7,19,6,19s0.5-0.1,0.7-0.3l5.3-5.3l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3   c0.4-0.4,0.4-1,0-1.4L13.4,12l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L12,10.6L6.7,5.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4   l5.3,5.3l-5.3,5.3C4.9,17.7,4.9,18.3,5.3,18.7z"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup-pwa',

  data() {
    return {
      deferredPrompt: null
    }
  },
  created() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      console.log('beforeinstallprompt')
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e
    })
    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null
    })
  },
  methods: {

    firstPopup() {
      return this.timePassed() && this.checkIfMobileByUA() && !localStorage.getItem('popup-app-install')
    },

    neverPopup() {
      let popupDismiss = localStorage.getItem('popup-app-install-never')
      console.log('never', popupDismiss || !this.timePassed());
      return popupDismiss || !this.timePassed()
    },

    timePassed() {
      let popupDismiss = localStorage.getItem('popup-app-install')
      if (!popupDismiss) {
        return true
      }
      let date = new Date(parseInt(popupDismiss))
      let mounthDate = new Date(date.setMonth(date.getMonth() + 1))
      return new Date() >= mounthDate
    },

    async closePopup() {
      localStorage.setItem('popup-app-install', Date.now())
      this.$forceUpdate()
      console.log(this.timePassed())
    },

    async dismiss() {
      this.deferredPrompt = null
      if (this.firstPopup()) {
        localStorage.setItem('popup-app-install', Date.now())
      } else {
        localStorage.setItem('popup-app-install-never', true)
      }
    },
    async install() {
      this.deferredPrompt.prompt()
      this.deferredPrompt.userChoice.then((choice) => {
        this.dismiss() // Hide the prompt once the user's clicked
        console.log(choice.outcome, choice)
        if (choice.outcome === 'accepted') {
          // Do something additional if the user chose to install
        } else {
          // Do something additional if the user declined
        }
      })
    },
    checkIfMobileByUA() {
      var ua = navigator.userAgent.toLowerCase()
      var isAndroid = ua.indexOf('android') > -1
      var isIos = ua.indexOf('iphone') > -1
      var isMobile = isAndroid || isIos
      return isMobile
    }
  }
}
</script>

<style>
</style>